/** Layout modes — resolved from pathname only (no window measurement). */
export const LAYOUT_MODE = {
    AUTH: "auth",
    APP: "app",
    ADMIN: "admin",
};

const AUTH_PATHS = new Set(["/login", "/register", "/admin/login", "/terms", "/privacy"]);

export function isAuthPath(pathname) {
    if (AUTH_PATHS.has(pathname)) return true;
    return pathname.startsWith("/invite/");
}

export function isAdminAppPath(pathname) {
    return pathname.startsWith("/admin") && !isAuthPath(pathname);
}

/** Single source of truth for which chrome layer is active. */
export function resolveLayoutMode(pathname) {
    if (isAuthPath(pathname)) return LAYOUT_MODE.AUTH;
    if (isAdminAppPath(pathname)) return LAYOUT_MODE.ADMIN;
    return LAYOUT_MODE.APP;
}
